class CountdownTimer {
  constructor(element) {
    this.element = element;
    this.interval = null;

    try {
      this.endDate = this.parseDate(element.dataset.endDate);

      if (!this.endDate || isNaN(this.endDate.getTime())) {
        this.element.style.display = "none";
        return;
      }

      this.timerText = element.dataset.timerText;
      this.start();
    } catch (err) {
      this.element.style.display = "none";
    }
  }

  parseDate(dateStr) {
    const parts = dateStr.trim().split(" ");
    const datePart = parts[0];
    const timePart = parts[1] || "00:00:00";

    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, min, sec] = timePart.split(":").map(Number);

    return new Date(year, month - 1, day, hour || 0, min || 0, sec || 0);
  }

  start() {
    this.updateTimer();
    // Update only every minute (SECONDS REMOVED)
    this.interval = setInterval(() => this.updateTimer(), 60000);
  }

  updateTimer() {
    const now = new Date().getTime();
    const distance = this.endDate.getTime() - now;

    if (distance <= 0) {
      clearInterval(this.interval);
      this.element.innerHTML = "";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

    // SECONDS REMOVED
    this.element.innerHTML = `${this.timerText}: ${days}d ${hours}h ${minutes}m`;
  }
}

function initAnnouncementTimers() {
  document.querySelectorAll('.js-countdown-timer').forEach(el => {
    if (!el.dataset.initialized && el.dataset.endDate) {
      el.dataset.initialized = "true";
      new CountdownTimer(el);
    }
  });
}

document.addEventListener("DOMContentLoaded", initAnnouncementTimers);
document.addEventListener("shopify:section:load", initAnnouncementTimers);
